// Import team data
import Client1 from "../assets/images/client/01.jpg";
import Client2 from "../assets/images/client/02.jpg";
import Client3 from "../assets/images/client/03.jpg";
import Client4 from "../assets/images/client/04.jpg";

export const teamData = {
  "01": {
    name: "ANAND SAHAI",
    role: "Global Delivery Head, US/UAE",
    description: `Anand has over 2 decades of experience in managing delivery of large and complex data engineering and AI-ML engagements. He brings deep understanding of data, cloud and supply chain. He was formerly with Deloitte Consulting and class topper at IIT Kanpur.`,
    image: Client1,
    email: "anand.sahai@numantratech.ai",
  },
  "02": {
    name: "RAJEEV SURANA",
    role: "EMEA Head, Switzerland",
    description: `Rajeev is a Swiss based ex-Deloitte consultant with a unique blend of business, technology and data skills. He has led more than 50 large scale data and digital transformations that have yielding new revenues and optimized costs and efficiencies. He has deep expertise in Healthcare, Medical devices, Pharmaceuticals and Engineering businesses.`,
    image: Client2,
    email: "rajeev.surana@numantratech.ai",
  },
  "03": {
    name: "THEO VAN DEN HEUVEL",
    role: "Data Science Lead, Netherlands",
    description: `Theo is an expert in data science and AI-ML based technologies. 
He brings special expertise in application of advanced analytics to the LifeSciences and healthcare context.`,
    image: Client3,
    email: "theo.vdheuvel@numantratech.ai",
  },
  // "04": {
  //   name: "New Name",
  //   role: "New Role",
  //   description: `New Description`,
  //   image: Client4,
  //   // email: "info@adina.com",
  // },
};
